import React from 'react';
import './overlay.styles.scss'; // Import the CSS file for styling

const OverlayContainer = () => {
  return (
    <div className="overlay-container"></div>
  );
};

export default OverlayContainer;